import { findControls, sliderThumbs } from "@plugins";

const service = document.querySelector(".js-service");

if (service) {
    const serviceSliderContainer = service.querySelector(".js-service-slider");
    const serviceSliderControls = findControls(service, ".js-service-controls");

    sliderThumbs(service, serviceSliderContainer, serviceSliderControls);
}
